<template>
  <div>
    <v-card class="shadow rounded-lg">
      <v-progress-linear :value="progress" color="primary" height="7" striped></v-progress-linear>

      <Tabs :step.sync="stepVal"/>

      <v-card-text class="pt-10 px-15">

        <v-radio-group v-model="form.type"
                       row
                       label="Type *"
        >
          <v-radio label="Spin to win" value="spintowin"/>
          <v-radio label="Memory game" value="memory_game"/>
        </v-radio-group>

        <v-text-field v-model="form.name" dense label="Nom *" outlined/>

        <v-row>

          <v-col>
            <v-menu v-model="menu1"
                    :close-on-content-click="false"
                    max-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="form.start_date"
                              clearable
                              dense
                              label="Date de début *"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              @click:prepend-inner="menu1 = true"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.start_date"
                             :min="dateNow"
                             @change="[menu1 = false,form.end_date='']"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col>
            <v-menu v-model="menu2"
                    :close-on-content-click="false"
                    max-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="form.end_date"
                              :disabled="!form.start_date"
                              clearable
                              dense
                              label="Date de fin *"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              @click:prepend-inner="menu2 = true"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.end_date"
                             :min="form.start_date"
                             @change="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-textarea v-model="form.description"
                    dense
                    label="Description"
                    outlined
                    rows="2"/>


        <div v-if="form.type === 'memory_game'" class="mb-6">

          <div class="v-label mb-4">Image d'arrière-plan du jeu *</div>
          <v-row class="mb-4">
            <v-col cols="12" md="6">
              <v-file-input :value="form.memory_background_image.file"
                            accept="image/png,image/jpeg"
                            outlined
                            dense
                            clearable
                            hide-details="auto"
                            label="Image d'arrière-plan"
                            @change="uploadMemoryBackground"/>
              <v-img v-if="form.memory_background_image.preview || form.memory_background_image.existing"
                     :src="form.memory_background_image.preview || fileUrl(form.memory_background_image.existing)"
                     height="80"
                     contain
                     class="mt-2 rounded"/>
            </v-col>
          </v-row>

          <div class="v-label mb-4">Images du jeu (6 images) *</div>
          <v-row>
            <v-col v-for="(img, i) in form.memory_images" :key="i" cols="12" md="4">
              <v-file-input :value="img.file"
                            accept="image/png,image/jpeg"
                            outlined
                            dense
                            hide-details="auto"
                            :label="`Image ${i + 1} *`"
                            @change="uploadMemoryImage($event, i)"/>
              <v-img v-if="img.preview || img.existing"
                     :src="img.preview || fileUrl(img.existing)"
                     height="80"
                     contain
                     class="mt-2 rounded"/>
            </v-col>
          </v-row>
        </div>


        <v-row>

          <v-col class="d-flex flex-column" cols="12" lg="6">
            <v-card class="rounded-lg flex d-flex flex-column" outlined>
              <v-card-text class="mb-0 pb-0 flex">
                <v-color-picker v-model="form.color" hide-canvas hide-mode-switch mode="hexa" width="100%"/>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="d-flex flex-column" cols="12" lg="6">
            <v-card class="rounded-lg flex d-flex flex-column" outlined>
              <v-card-text class="mb-0 pb-0 flex">
                <v-layout align-center="" class="text-center" justify-center="">
                  <v-flex shrink>
                    <div class="profile-img">

                      <v-img v-if="isUpload"
                             :src="form.image ? form.image : require('@/assets/no-image.png')"
                             class="rounded-circle"
                             height="90"
                             width="90">
                      </v-img>


                      <v-img v-else
                             :src="form.image ? ($route.params.id ? $baseUrl+form.image : form.image ): require('@/assets/no-image.png')"
                             class="rounded-circle"
                             height="90"
                             width="90">
                      </v-img>

                    </div>

                    <v-btn v-if="!form.image"
                           class="btn-upload"
                           color="primary"
                           dark
                           depressed
                           fab
                           x-small
                           @click="onButtonClick">
                      <v-icon>mdi-camera</v-icon>
                    </v-btn>

                    <v-btn v-if="form.image"
                           class="btn-upload"
                           color="red"
                           dark
                           depressed
                           fab
                           x-small
                           @click="form.image = null">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                  </v-flex>
                </v-layout>

                <input ref="image"
                       accept="image/png,image/jpeg"
                       class="d-none"
                       type="file"
                       @change="uploadImage($event)">
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>


      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="secondary"
               depressed
               @click="$emit('next')">
          Suivant
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import Tabs from "@/views/v2_campaigns/create/components/Tabs.vue";

const STORAGE_PREFIX = "/";

export default {
  props: {
    step: {
      type: Number
    },
    form: Object
  },
  components: {Tabs},
  data() {
    return {
      progress: 0,
      menu1: false,
      menu2: false,
      isUpload: false,
      dateNow: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }
  },
  watch: {
    'form.type': {
      immediate: true,
      handler(type) {
        if (type === 'memory_game') {
          while (this.form.memory_images.length < 6) {
            this.form.memory_images.push({file: null, preview: null, data: null, existing: null})
          }
          if (!this.form.memory_background_image) {
            this.$set(this.form, 'memory_background_image', {file: null, preview: null, data: null, existing: null})
          }
        }
      }
    }
  },
  beforeDestroy() {
    this.form.memory_images.forEach(i => i.preview && URL.revokeObjectURL(i.preview))
    const bg = this.form.memory_background_image
    if (bg && bg.preview) URL.revokeObjectURL(bg.preview)
  },
  methods: {
    fileUrl(path) {
      if (!path) return "";
      if (/^(https?:|blob:|data:)/.test(path)) return path;
      const base = (process.env.VUE_APP_BASE_URL).replace(/\/$/, "");
      return `${base}${STORAGE_PREFIX}${String(path).replace(/^\/+/, "")}`;
    },
    uploadMemoryImage(file, index) {
      const img = this.form.memory_images[index]
      if (img.preview) URL.revokeObjectURL(img.preview)   // avoid memory leak

      if (!file) {
        // cleared: fall back to the existing server image if any
        this.$set(img, 'file', null)
        this.$set(img, 'preview', null)
        this.$set(img, 'data', null)
        return
      }

      this.$set(img, 'file', file)
      this.$set(img, 'preview', URL.createObjectURL(file))

      const reader = new FileReader()
      reader.onloadend = () => this.$set(img, 'data', reader.result)   // base64 for the API
      reader.readAsDataURL(file)
    },
    uploadImage(event) {
      let files = event.target.files
      let file = files[0]
      if (file) {
        const reader = new FileReader()
        reader.onloadend = () => {
          this.isUpload = true
          this.form.image = reader.result
        }
        reader.readAsDataURL(file)
      }
    },
    uploadMemoryBackground(file) {
      const bg = this.form.memory_background_image
      if (bg.preview) URL.revokeObjectURL(bg.preview)

      if (!file) {
        this.$set(bg, 'file', null)
        this.$set(bg, 'preview', null)
        this.$set(bg, 'data', null)
        return
      }

      this.$set(bg, 'file', file)
      this.$set(bg, 'preview', URL.createObjectURL(file))

      const reader = new FileReader()
      reader.onloadend = () => this.$set(bg, 'data', reader.result)
      reader.readAsDataURL(file)
    },
    onButtonClick() {
      window.addEventListener('focus', () => {
      }, {once: true})
      this.$refs.image.click()
    },
  },
  mounted() {
    this.$vuetify.goTo(0)
    let _vm = this
    setTimeout(function () {
      _vm.progress += 33
    }, 500)
  },
  computed: {
    stepVal: {
      get: function () {
        return this.step;
      },
      set: function (newValue) {
        this.$emit('update:step', newValue)
      }
    },
  }
}
</script>

<style scoped>
.profile-img {
  border: solid 1px #e9ebec;
  border-radius: 50%;
  padding: 5px;
}

.btn-upload {
  margin-right: -75px;
  margin-top: -50px
}
</style>